import FuseAnimateGroup from '@fuse/core/FuseAnimateGroup';
import FuseUtils from '@fuse/utils';
import { InputAdornment } from '@material-ui/core';
import { amber } from '@material-ui/core/colors';
import Divider from '@material-ui/core/Divider';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import SearchIcon from '@material-ui/icons/Search';
import * as UserActions from 'app/auth/store/actions';
import navigationConfig from 'app/fuse-configs/navigationConfig';
import authService from 'app/services/authService';
import * as Actions from 'app/store/actions';
import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const useStyles = makeStyles({
  root: {
    '&.horizontal': {},
    '&.vertical': {
      flexDirection: 'column',
    },
  },
  item: {
    textDecoration: 'none!important',
    color: 'inherit',
  },
  addIcon: {
    color: amber[600],
  },
});

function FuseShortcuts(props) {
  const dispatch = useDispatch();
  const shortcuts = useSelector(({ auth }) => auth.user.data.shortcuts);
  const navigationData = useSelector(({ fuse }) => fuse.navigation);

  const classes = useStyles(props);
  const searchInputRef = useRef(null);
  const [addMenu, setAddMenu] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [searchResults, setSearchResults] = useState(null);
  const [titulosMenu, setTitulosMenu] = useState([]);
  const shortcutItems = shortcuts ? shortcuts.map((id) => FuseUtils.findById(navigationData, id)) : [];
  const handleClick = (ev, item) => {
    if (item.id === 'relatorios') {
      let possuiPermissão = item.authority.some((auth) => authService.hasAuthority(auth));

      if (!possuiPermissão) {
        ev.preventDefault();
        dispatch(
          Actions.showMessage({
            message: 'Você não possui permissão para acessar esta tela.',
            variant: 'error',
          })
        );
      }
    }
  };

  useEffect(() => {
    getTitulosMenu();
  }, [props.location, navigationData]);

  function addMenuClick(event) {
    setAddMenu(event.currentTarget);
  }

  function addMenuClose() {
    setAddMenu(null);
  }

  function search(ev) {
    const newSearchText = ev.target.value;

    setSearchText(newSearchText);

    if (newSearchText && newSearchText.length > 0 && navigationConfig) {
      setSearchResults(
        titulosMenu.filter((ob) =>
          ob.title
            .toLowerCase()
            .normalize('NFD')
            .replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '')
            .includes(
              newSearchText
                .toLowerCase()
                .normalize('NFD')
                .replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '')
            )
        )
      );
      return;
    }
    setSearchResults(null);
  }

  function getTitulosMenu() {
    const navigation = navigationConfig;
    let gestoes = [];
    let cadastros = [];
    let objeto = [];

    navigation.forEach((n) => {
      if (n.gestao || n.cadastro) {
        gestoes.push(n.gestao);
        cadastros.push(n.cadastro);
      } else {
        objeto.push(n);
      }
    });
    gestoes.forEach((arrayInterno) => {
      if (arrayInterno !== undefined && arrayInterno.length > 0) {
        arrayInterno.forEach((ob) => {
          objeto.push(ob);
        });
      }
    });

    cadastros.forEach((arrayInterno) => {
      if (arrayInterno !== undefined && arrayInterno.length > 0) {
        arrayInterno.forEach((ob) => {
          objeto.push(ob);
        });
      }
    });
    setTitulosMenu(objeto);
  }

  function toggleInShortcuts(id) {
    let newShortcuts = [...shortcuts];
    newShortcuts = newShortcuts.includes(id) ? newShortcuts.filter((_id) => id !== _id) : [...newShortcuts, id];
    dispatch(UserActions.updateUserShortcuts(newShortcuts));
  }

  function ShortcutMenuItem({ item, onToggle }) {
    const tipoString = typeof item.icon === 'string';
    const CustomIcon = item.icon;

    const setIcon = tipoString ? <Icon>{item.icon}</Icon> : <CustomIcon size={23} />;
    const setTitle = <span className="text-20 font-bold uppercase">{item.title}</span>;
    const setLayout = item.icon ? setIcon : setTitle;

    return (
      <Link to={item.url} className={classes.item} role="button" onClick={(ev) => handleClick(ev, item)}>
        <MenuItem key={item.id}>
          <ListItemIcon className="min-w-40">{setLayout}</ListItemIcon>
          <ListItemText primary={item.title} />
          <IconButton
            onClick={(ev) => {
              ev.preventDefault();
              ev.stopPropagation();
              onToggle(item.id);
            }}
          >
            <Icon className={classes.addIcon} color="action">
              {shortcuts.includes(item.id) ? 'star' : 'star_border'}
            </Icon>
          </IconButton>
        </MenuItem>
      </Link>
    );
  }

  return (
    <div
      className={clsx(
        classes.root,
        props.variant,
        'flex flex-1',
        props.variant === 'vertical' && 'flex-grow-0 flex-shrink',
        props.className
      )}
    >
      <FuseAnimateGroup
        enter={{
          animation: 'transition.expandIn',
        }}
        className={clsx('flex flex-1', props.variant === 'vertical' && 'flex-col')}
      >
        <div className="stepFavoritos">
          <Tooltip
            title="Clique para adicionar ou remover uma página favorita."
            placement={props.variant === 'horizontal' ? 'bottom' : 'left'}
          >
            <IconButton
              className="w-40 h-40 p-0"
              aria-owns={addMenu ? 'add-menu' : null}
              aria-haspopup="true"
              onClick={addMenuClick}
            >
              <Icon className={classes.addIcon}>star</Icon>
            </IconButton>
          </Tooltip>
        </div>

        {shortcutItems.map((item) => {
          const tipoString = typeof item.icon === 'string';
          const CustomIcon = item.icon;

          const setIcon = tipoString ? <Icon>{item.icon}</Icon> : <CustomIcon size={23} />;
          const setTitle = <span className="text-20 font-bold uppercase">{item.title}</span>;
          const setLayout = item.icon ? setIcon : setTitle;

          const definePlacement = props.variant === 'horizontal' ? 'bottom' : 'right';
          return (
            <Link
              to={item.url}
              key={item.id}
              className={classes.item}
              role="button"
              onClick={(ev) => handleClick(ev, item)}
            >
              <Tooltip title={item.title} placement={definePlacement}>
                <IconButton className="w-40 h-40 p-0">{setLayout}</IconButton>
              </Tooltip>
            </Link>
          );
        })}
      </FuseAnimateGroup>

      <Menu
        id="add-menu"
        anchorEl={addMenu}
        open={Boolean(addMenu)}
        onClose={addMenuClose}
        classes={{
          paper: 'mt-48',
        }}
        onEntered={() => {
          searchInputRef.current.focus();
        }}
        onExited={() => {
          setSearchText('');
        }}
      >
        <div className="p-16 pt-8">
          <Input
            inputRef={searchInputRef}
            value={searchText}
            onChange={search}
            placeholder="Pesquisar página..."
            className=""
            fullWidth
            inputProps={{
              'aria-label': 'Pesquisar',
            }}
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            }
          />
        </div>

        <Divider />

        {searchText.length !== 0 &&
          searchResults &&
          searchResults.map((item) => (
            <ShortcutMenuItem key={item.id} item={item} onToggle={() => toggleInShortcuts(item.id)} />
          ))}

        {searchText.length !== 0 && searchResults.length === 0 && (
          <Typography color="textSecondary" className="p-16 pb-8">
            Nenhum registro foi encontrado
          </Typography>
        )}

        {searchText.length === 0 &&
          shortcutItems.map(
            (item) => item && <ShortcutMenuItem key={item.id} item={item} onToggle={() => toggleInShortcuts(item.id)} />
          )}
      </Menu>
    </div>
  );
}

FuseShortcuts.defaultProps = {
  variant: 'horizontal',
};

export default React.memo(FuseShortcuts);
